var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 437.71 437.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bold-Outline-381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape-339",
    className: "cls-1",
    d: "m87.53,0h262.64c48.34,0,87.53,39.19,87.53,87.53h0v262.64c0,48.34-39.19,87.53-87.53,87.53H87.53c-48.34,0-87.53-39.19-87.53-87.53h0V87.53C0,39.19,39.19,0,87.53,0Zm0,43.77c-24.17,0-43.77,19.59-43.77,43.77v262.64c0,24.17,19.59,43.77,43.77,43.77h262.64c24.17,0,43.77-19.59,43.77-43.77h0V87.53c0-24.17-19.59-43.77-43.77-43.77H87.53Zm223.72,138.92c19.98,13.61,25.14,40.83,11.53,60.81-3.09,4.53-7,8.45-11.53,11.53l-111.54,75.98c-19.98,13.61-47.2,8.45-60.81-11.53-4.95-7.27-7.6-15.85-7.6-24.65v-151.95c0-24.17,19.59-43.77,43.76-43.77,8.79,0,17.38,2.65,24.65,7.6l111.54,75.96Zm-136.17-39.79v151.95l111.54-75.98-111.54-75.96Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.8c77f07b9bd0a989eebdf88053d35d6d.svg";
export { ForwardRef as ReactComponent };